import { Box, Stack, styled } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import dayjs from 'dayjs'
import { ReactNode } from 'react'
import { Radio } from 'components/ui'

const ItemContainer = styled(Stack)`
  height: 48px;
  background: white;
  align-items: center;
  padding: 0 32px;
  border-radius: 8px;
  flex-direction: row;
  gap: 32px;
  cursor: pointer;
  &:active {
    opacity: 0.7;
  }
`

export const StoredDeliveriesListDetailsItem = ({
  date,
  binName,
  icon,
  onClick,
}: {
  date: string
  binName: string
  icon: ReactNode
  onClick: () => void
}) => {
  return (
    <ItemContainer onClick={onClick}>
      <div>{dayjs(date)?.format('DD.MM.YY')}</div>
      <div>{dayjs(date)?.format('HH:mm')}</div>
      <div>{binName}</div>
      <Box flex={1} textAlign={'right'}>
        <IconButton>{icon}</IconButton>
      </Box>
    </ItemContainer>
  )
}

export const GroupDetailsItem = ({
  date,
  binName,
  icon,
  grouped,
  onClick,
  disabled,
}: {
  date: string
  binName: string
  icon: ReactNode
  grouped: boolean
  onClick?: () => void
  disabled?: boolean
}) => {
  return (
    <ItemContainer
      sx={{
        background: (theme) => theme.palette.grey[100],
        border: (theme) => `1px solid ${theme.palette.grey[300]}`,
        padding: '0 16px',
        pointerEvents: disabled ? 'none' : 'unset',
      }}
    >
      <div>
        <Radio
          disabled={disabled}
          sx={{
            '&.Mui-checked.Mui-disabled': {
              color: '#1976d2',
            },
          }}
          checked={grouped}
          onClick={onClick}
        />
      </div>
      <div>{dayjs(date).format('DD.MM.YY')}</div>
      <div>{dayjs(date).format('HH:mm')}</div>
      <div>{binName}</div>
      <Box flex={1} textAlign={'right'}>
        <IconButton disabled={disabled}>{icon}</IconButton>
      </Box>
    </ItemContainer>
  )
}
